import { aboutFeatures, statsData } from "@/mocks/homeData";

export default function About() {
  return (
    <section className="w-full py-16 md:py-24 bg-accent-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16">
          <span className="inline-block bg-white px-5 py-2 rounded-full text-sm font-semibold text-foreground-800 mb-6">
            2026 Updated
          </span>
          <h2 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
            Smart Product
            <br />
            Tracking System
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-14 md:mb-20">
          {aboutFeatures.map((feature, idx) => (
            <div key={idx} className="flex flex-col gap-3 bg-white/60 rounded-2xl overflow-hidden group cursor-default">
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={feature.imageUrl}
                  alt={feature.title}
                  title={`OOPBuy Spreadsheet - ${feature.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="px-4 pb-4 flex flex-col gap-2">
                <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide">
                  {feature.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-accent-800 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600 font-medium uppercase tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}